/**
 * UI checklist only — mirrors dashboard rules for opening the signature editor.
 */

export function evaluateSignatureSendReadiness(contract) {
  const items = [];
  const jobId = contract?.job_id;

  items.push({
    id: "job_id",
    label: "Documento identificado",
    ok: Boolean(jobId),
    detail: jobId ? `ID ${String(jobId).slice(0, 8)}…` : "Sem identificador do documento.",
  });

  const isUpload = Boolean(contract?.is_manual_signature);
  const status = contract?.status;

  let pdfOk = false;
  if (isUpload) {
    pdfOk =
      status === "PDF_UPLOADED" ||
      status === "PDF_GENERATED" ||
      status === "PENDING_SIGNATURE";
  } else {
    pdfOk = status === "PDF_GENERATED" || status === "PENDING_SIGNATURE";
  }

  items.push({
    id: "pdf_ready",
    label: isUpload ? "PDF enviado e pronto para assinatura" : "PDF gerado no sistema",
    ok: pdfOk,
    detail: pdfOk
      ? "O PDF está disponível para configurar assinatura."
      : isUpload
        ? "Aguarde o upload/processamento do PDF."
        : "Gere o PDF antes de enviar para assinatura.",
  });

  items.push({
    id: "not_signed",
    label: "Status permite configurar assinatura",
    ok: status !== "SIGNED",
    detail:
      status === "SIGNED"
        ? "Documento já assinado."
        : "Você poderá posicionar campos no próximo passo.",
  });

  const blockers = items.filter((i) => !i.ok);
  return {
    items,
    ready: blockers.length === 0,
    blockers,
  };
}
